import  UIkit from "uikit" 

export const showNotification =  (data?:UIkit.UIkitNotificationOptions, iconClass?:string) =>{
    UIkit?.notification({message: `<span class=\'${iconClass}\'></span> ${data?.message}`, status: data?.status, pos: data?.pos, timeout: data?.timeout});
}
